import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Context } from "../../Context";
import TopBar from "./TopBar";
import { GET_ALL_CATEGORIES, GET_BUSINESS_CATEGORIES, GET_CARPOOL_LIST, GET_MOVIE_LANGUAGES, STATE_SEARCH, COUNTRY_SEARCH, fetchData } from "../../Service";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Select from "react-select";
import { setCookie } from "nookies";

const Header = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const [context] = useContext(Context);
	const [carpoolMenu, setCarpoolMenu] = useState([]);
	const [movieLangMenu, setMovieLangMenu] = useState([]);
	const [freeAdsCatList, setFreeAdsCatMenu] = useState([]);
	const [businessCatList, setBusinessCatMenu] = useState([]);

	const [selectedCountry, setSelectedCountry] = useState(null);
	const [selectedState, setSelectedState] = useState(null);

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		reset,
	} = useForm({ mode: "onChange" });

	const getCarpoolList = () => {
		fetchData(GET_CARPOOL_LIST, "GET", "", false, false, (res) => {
			if (res.status) {
				setCarpoolMenu(res.data);
			} else {
				console.log(res);
			}
		});
	};

	const getMovieLangList = () => {
		fetchData(GET_MOVIE_LANGUAGES, "GET", "", false, false, (res) => {
			if (res.status) {
				setMovieLangMenu(res.data);
			} else {
				console.log(res);
			}
		});
	};

	const getFreeAdsCatList = () => {
		fetchData(GET_ALL_CATEGORIES, "GET", "", false, false, (res) => {
			if (res.status) {
				setFreeAdsCatMenu(res.data);
			} else {
				console.log(res);
			}
		});
	};

	const getBusinessCatList = (country_id) => {
		fetchData(GET_BUSINESS_CATEGORIES, "POST", { country_id: country_id }, false, false, (res) => {
			if (res.status) {
				setBusinessCatMenu(res.data);
			} else {
				console.log(res);
			}
		});
	};

	const changeCountry = (country_id) => {
		if (country_id) {
			setCookie(null, "CountryID", country_id, {
				maxAge: 2 * 24 * 60 * 60, // 2 day
				path: "/",
				domain: ".nris.com",
				secure: true,
				httpOnly: false,
				sameSite: "lax",
			});

			window.location.href = `https://${process.env.REACT_APP_DOMAIN_URL}`;
		}
	};

	const changeState = (state_id, subdomain) => {
		if (state_id) {
			window.location.href = `https://${subdomain}.${process.env.REACT_APP_DOMAIN_URL}`;
		}
	};

	const checkLocation = (url) => {
		let match = url.some((l) => location.pathname.match(l));

		return match;
	};

	const searchResult = (data) => {
		let payload = {
			country_id: context?.countryId,
			keyword: data.search_keyword,
		};

		if (context?.stateView) {
			payload = { ...payload, state_id: context?.stateId };
		}
		fetchData(context?.stateView ? STATE_SEARCH : COUNTRY_SEARCH, "POST", payload, false, false, (res) => {
			if (res.status) {
				localStorage.setItem("_nrissearch", data.search_keyword);

				navigate("/search-results", { state: { search_result: res?.data } });
			} else {
				toast.error("No search results found.");
			}
		});
	};

	useEffect(() => {
		getCarpoolList();
		getMovieLangList();
		getFreeAdsCatList();
	}, []);

	useEffect(() => {
		if (context?.countryId) {
			getBusinessCatList(context?.countryId);
		}
	}, [context?.countryId]);

	useEffect(() => {
		window.$(document).ready(function () {
			window.$(".burger-icon").click(function () {
				window.$("#m-mrnu").addClass("sidebar-visible");
			});
			window.$("#close-menu").click(function () {
				window.$("#m-mrnu").removeClass("sidebar-visible");
			});
		});

		document.getElementById("m-mrnu").addEventListener("click", function (event) {
			if (event.target.tagName.toLowerCase() === "a") {
				window.$("#m-mrnu").removeClass("sidebar-visible");
			}
		});
	}, []);

	useEffect(() => {
		const defCountry = context?.countryList?.filter((item) => context?.countryId == item.id)[0];
		const defState = context?.stateList?.filter((item) => context?.stateId == item.id)[0];
		if (defCountry && defState) {
			setSelectedCountry(defCountry ? { label: defCountry.name, value: defCountry.id } : null);
			setSelectedState(defState ? { label: defState.name, value: defState.id } : null);
		}
	}, [context?.countryList, context?.stateList]);

	return (
		<>
			<Helmet>
				{context?.countryId == 1 && <link href="/assets/css/usa_theme.css" rel="stylesheet" />}
				{context?.countryId == 2 && <link href="/assets/css/can_theme.css" rel="stylesheet" />}
				{context?.countryId == 3 && <link href="/assets/css/aus_theme.css" rel="stylesheet" />}
				{context?.countryId == 4 && <link href="/assets/css/nzl_theme.css" rel="stylesheet" />}
				{context?.countryId == 10 && <link href="/assets/css/uk_theme.css" rel="stylesheet" />}
			</Helmet>
			<header className="header sticky-top">
				<TopBar />
				<div className="container-fluis">
					<div className="main-header banner-hero">
						<div className="header-left">
							<div className="header-logo">
								<Link className="d-flex" to="/">
									<img title="NRIS" src="/assets/images/logo.png" alt="..." />
								</Link>
							</div>
						</div>
						<div className="header-nav ms-auto text-end mb-1">
							<nav className="nav-main-menu">
								<ul className="main-menu">
									<li className="has-children">
										<a className={checkLocation(["/nri-talks", "/forums", "/student-talks"]) || location.pathname === "/" ? "active" : ""} href="#">
											Our Pages
										</a>
										<ul className="sub-menu">
											<li>
												<Link to="/forums">Forums</Link>
											</li>
											<li>
												<Link to="/nri-talks">Nris Talk</Link>
											</li>
											<li>
												<Link to="/student-talks">Student Talk</Link>
											</li>
										</ul>
									</li>
									<li>
										<Link to="/real-estate" className={checkLocation(["/real-estate"]) ? "active" : ""}>
											Real Estate
										</Link>
									</li>
									<li className="has-children">
										<a className={checkLocation(["/carpool"]) ? "active" : ""} href="#!">
											Carpool
										</a>
										<ul className="sub-menu">
											{carpoolMenu?.map((item) => (
												<li key={item.id}>
													<Link to={`/carpool/${item.id}`} state={{ pageTitle: item.name }}>
														{item.name}
													</Link>
												</li>
											))}
										</ul>
									</li>
									<li>
										<Link to="autos" className={checkLocation(["/autos"]) ? "active" : ""}>
											Autos
										</Link>
									</li>
									<li className="has-children">
										<a className={checkLocation(["/movies"]) ? "active" : ""} href="#!">
											Movies/Videos
										</a>										
										<ul className="sub-menu">
											{movieLangMenu?.slice() 
												.sort((a, b) => a.name.localeCompare(b.name)) 
												.map((item) => (
												<li key={item.id}>
													<Link to={`/movies/${item.id}`} state={{ pageTitle: item.name }}>
														{item.name}
													</Link>
												</li>
											))}
										</ul>
									</li>
									<li className="has-children">
										<a className={checkLocation(["/classifieds"]) ? "active" : ""} href="#!">
											Free Ads
										</a>
										<ul className="sub-menu">
											{freeAdsCatList
												?.slice() 
												.sort((a, b) => a.name.localeCompare(b.name)) 
												.map((item) => (
													<li key={item.id}>
														{item.id == 5 ? (
															<Link to={`/real-estate`} state={{ pageTitle: item.name }}>
																{item.name}
															</Link>
														) : item.id == 1 ? (
															<Link to={`/autos`} state={{ pageTitle: item.name }}>
																{item.name}
															</Link>
														) : (
															<Link to={`/classifieds/${item.id}`} state={{ pageTitle: item.name }}>
																{item.name}
															</Link>
														)}
													</li>
												))}
										</ul>
									</li>
									<li>
										<Link to="/blogs" className={checkLocation(["/blogs"]) ? "active" : ""}>
											Blogs
										</Link>
									</li>
									<li className="has-children">
										<a href="#!" className={checkLocation(["/business"]) ? "active" : ""}>
											Business Listing
										</a>
										<ul className="sub-menu">
											{businessCatList?.slice() 
												.sort((a, b) => a.name.localeCompare(b.name)) 
												.map((item) => (
												<li key={item.id}>
													<Link to={`/business/${item.id}`} state={{ pageTitle: item.name }}>
														{item.name}
													</Link>
												</li>
											))}
										</ul>
									</li>
								</ul>
							</nav>

							<div className="burger-icon burger-icon-white">
								<span className="burger-icon-top"></span>
								<span className="burger-icon-mid"></span>
								<span className="burger-icon-bottom"></span>
							</div>
							<form className="input-group mt-1 d-xl-none searchm mx-auto ms-lg-auto" onSubmit={handleSubmit(searchResult)}>
								<input type="text" className="form-control" placeholder="What are you looking for" aria-label="Username" {...register("search_keyword")} />
								<span className="input-group-text p-0 bg-white">
									{" "}
									<button className="btn btn-default btn-find font-sm">
										<i className="fi fi-br-search d-inline-block d-sm-none"></i>
										<span className=" d-none d-sm-inline-block">Search</span>{" "}
									</button>
								</span>
							</form>
						</div>
						<div className="header-right ms-3">
							<div className="block-signin d-inline-flex">
								<Select
									options={context?.countryList?.map((item) => ({
										label: item.name,
										value: item.id,
										domain: item.domain,
									}))}
									value={selectedCountry}
									onChange={(selected) => {
										changeCountry(selected?.value);
										setSelectedCountry(selected);
									}}
									placeholder=""
									className={`selectpicker custom-react-select me-1 me-lg-0 ms-0 ms-lg-1 mt2px mb2px height30`}
									classNamePrefix="react-select"
								/>

								<Select
									options={context?.stateList?.map((item) => ({
										label: item.name,
										value: item.id,
										domain: item.domain,
									}))}
									value={selectedState}
									onChange={(selected) => {
										setSelectedState(selected?.value);
										changeState(selected?.value, selected?.domain);
									}}
									placeholder=""
									className={`selectpicker custom-react-select me-1 me-lg-0 ms-0 ms-lg-1 mt2px mb2px height30`}
									classNamePrefix="react-select"
								/>
							</div>
						</div>
					</div>
				</div>
			</header>
			<div className="mobile-header-active mobile-header-wrapper-style perfect-scrollbar" id="m-mrnu">
				<div className="mobile-header-wrapper-inner">
					<div className="mobile-header-content-area">
						<div className="perfect-scroll">
							<div className="mobile-search mobile-header-border text-end">
								<i className="fi fi-bs-cross" id="close-menu"></i>
							</div>
							<div className="mobile-menu-wrap mobile-header-border pb-4">
								<div className="header-right">
									<div className="block-signin d-inline-flex">
										<Select
											options={context?.countryList?.map((item) => ({
												label: item.name,
												value: item.id,
												domain: item.domain,
											}))}
											value={selectedCountry}
											onChange={(selected) => {
												changeCountry(selected?.value);
												setSelectedCountry(selected);
											}}
											placeholder=""
											className={`selectpicker custom-react-select me-1 me-lg-0 ms-0 ms-lg-1 mt2px mb2px height30`}
											classNamePrefix="react-select"
										/>

										<Select
											options={context?.stateList?.map((item) => ({
												label: item.name,
												value: item.id,
												domain: item.domain,
											}))}
											value={selectedState}
											onChange={(selected) => {
												setSelectedState(selected?.value);
												changeState(selected?.value, selected?.domain);
											}}
											placeholder=""
											className={`selectpicker custom-react-select me-1 me-lg-0 ms-0 ms-lg-1 mt2px mb2px height30`}
											classNamePrefix="react-select"
										/>
									</div>
								</div>
								<nav>
									<ul className="mobile-menu font-heading">
										<li className="has-children">
											<a className="active" href="#!">
												Our Pages
											</a>
											<ul className="sub-menu">
												<li>
													<Link to="/nri-talks">Nris Talk</Link>
												</li>
												<li>
													<Link to="/forums">Forums</Link>
												</li>
												<li>
													<Link to="/student-talks">Student Talk</Link>
												</li>
											</ul>
										</li>
										<li>
											<Link to="/real-estate">Real Estate</Link>
										</li>
										<li className="has-children">
											<a href="#!">Carpool</a>
											<ul className="sub-menu">
												{carpoolMenu?.map((item) => (
													<li key={item.id}>
														<Link to={`/carpool/${item.id}`} state={{ pageTitle: item.name }}>
															{item.name}
														</Link>
													</li>
												))}
											</ul>
										</li>
										<li>
											<Link to="/autos">Autos</Link>
										</li>
										<li className="has-children">
											<a href="#!">Movies/Videos</a>
											<ul className="sub-menu">
												{movieLangMenu?.map((item) => (
													<li key={item.id}>
														<Link to={`/movies/${item.id}`} state={{ pageTitle: item.name }}>
															{item.name}
														</Link>
													</li>
												))}
											</ul>
										</li>
										<li className="has-children">
											<a href="#!">Free Ads</a>
											<ul className="sub-menu">
												{freeAdsCatList?.map((item) => (
													<li key={item.id}>
														{item.id == 5 ? (
															<Link to={`/real-estate`} state={{ pageTitle: item.name }}>
																{item.name}
															</Link>
														) : item.id == 1 ? (
															<Link to={`/autos`} state={{ pageTitle: item.name }}>
																{item.name}
															</Link>
														) : (
															<Link to={`/classifieds/${item.id}`} state={{ pageTitle: item.name }}>
																{item.name}
															</Link>
														)}
													</li>
												))}
											</ul>
										</li>
										<li>
											<Link to="/blogs">Blogs</Link>
										</li>
										<li className="has-children">
											<a href="#!">Business Listing</a>
											<ul className="sub-menu">
												{businessCatList?.map((item) => (
													<li key={item.id}>
														<Link to={`/business/${item.id}`} state={{ pageTitle: item.name }}>
															{item.name}
														</Link>
													</li>
												))}
											</ul>
										</li>
									</ul>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Header;
